document.addEventListener('algolia.hooks.initialize', function() {

  // Customer login check
  const isCustomerLoggedIn = document.body.classList.contains('customer-logged-in') || 
    !!(window.__st?.cid) || 
    !!(window.ShopifyAnalytics?.meta?.page?.customerId);
  
  algoliaShopify.hooks.registerHook('beforeAutocompleteOptions', function(options) {
    /*Change the placeholder text of the autocomplete menu*/
    options.placeholder = "Search Tranzmile Products";
    return options;
  });

  algoliaShopify.hooks.registerHook(
    'beforeAutocompleteProductTemplate',
    function (_defaultTemplate, templateOptions, distinct, itemLink, trackSearchAttribution) {
      const { html, item, components } = templateOptions;

      // 1. Apply your custom image logic to the item object
      let placeholder = "https://cdn.shopify.com/s/files/1/0790/6030/4123/files/No-img.png";
      let imageUrl = item.image ? item.image : placeholder;
      let srcset = item.srcset || '';
      
      try {
        // Logic to increase image size
        imageUrl = imageUrl.replace('_125x', '_256x');
        srcset = srcset
          .replace('_125x', '_256x')
          .replace('_250x', '_400x')
          .replace('_375x', '_600x');
      } catch (e) {
        console.log("Image modification failed", e);
      }

      // 2. Return the new template including the SKU
      return html`
        <a href="${itemLink}" class="aa-ItemLink aa-ProductItem" onClick="${() => trackSearchAttribution(item)}">
          <div class="aa-ItemContent">
            <div class="aa-ItemPicture aa-ItemPicture--loaded">
              <img 
                src="${imageUrl}" 
                srcset="${srcset}" 
                sizes="(max-width: 256px) 100vw, 256px" 
                alt="${item.title}" 
              />
            </div>
            <div class="aa-ItemContentBody">
              <div class="aa-ItemContentTitleWrapper">
                  <div class="aa-ItemContentTitle">${components.Highlight({ hit: item, attribute: 'title' })} <span class="algolia-variant"></span>
                  </div>
                </div>
              <!-- Added SKU display below the title -->
              <div class="aa-ItemContentDescription aa-ItemSKU" style="font-size: 0.8em; color: #666;">
                SKU: ${components.Highlight({ hit: item, attribute: 'sku' })}
              </div>
              <div class="aa-ItemContentPrice">
                <div class="aa-ItemContentPriceCurrent${isCustomerLoggedIn ? ' login_member_price' : ''}">
                  ${algoliaShopify.helpers.displayPrice(item)}
                </div>

                ${
                  item.meta?.custom?.custom_member_price
                    ? html`
                        <div class="aa-MemberPriceWrapper${isCustomerLoggedIn ? ' login_member_price' : ''}">
                          <span class="member-price-amount">
                            $${parseFloat(item.meta.custom.custom_member_price).toFixed(2)}
                          </span>

                          <span class="member-price-badge">
                            <svg width="105" height="45" viewBox="0 0 205 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <rect width="205" height="45" rx="4.5" fill="black"></rect>
                              <path d="M32.32 30.5H29.8225V14.8625H33.355L38.1025 24.605L42.7375 14.8625H46.2925V30.5H43.795V17.8775L39.205 27.3725H36.8875L32.32 17.8775V30.5ZM57.78 26.63L59.6925 27.6875C58.6575 29.735 56.9475 30.77 54.585 30.77C52.92 30.77 51.5475 30.23 50.4675 29.1725C49.3875 28.115 48.8475 26.7425 48.8475 25.0325C48.8475 23.345 49.3875 21.9725 50.445 20.915C51.5025 19.8575 52.83 19.3175 54.4275 19.3175C56.025 19.3175 57.285 19.8125 58.2075 20.825C59.13 21.8375 59.58 23.1875 59.58 24.875C59.58 25.2575 59.58 25.4825 59.5575 25.595H51.4125C51.57 27.575 52.74 28.79 54.6075 28.79C55.98 28.79 57.0375 28.07 57.78 26.63ZM54.36 21.23C52.7625 21.23 51.6375 22.2425 51.435 23.93H57.0825C56.925 22.1975 56.0025 21.23 54.36 21.23ZM75.1435 19.3175C77.7535 19.3175 79.1935 20.9375 79.1935 23.705V30.5H76.7635V23.9975C76.7635 22.2425 76.021 21.365 74.5135 21.365C72.961 21.365 71.8585 22.3775 71.8585 24.11V30.5H69.406V23.9975C69.406 22.2425 68.6635 21.365 67.1785 21.365C65.626 21.365 64.5235 22.3775 64.5235 24.0875V30.5H62.0935V19.5875H64.456V21.0275C65.221 19.88 66.346 19.3175 67.8085 19.3175C69.496 19.3175 70.6435 19.9475 71.296 21.23C72.1735 19.9475 73.456 19.3175 75.1435 19.3175ZM88.3195 30.77C86.587 30.77 85.327 30.095 84.517 28.745V30.5H82.1545V14.8625H84.5845V21.275C85.417 19.97 86.677 19.3175 88.342 19.3175C89.782 19.3175 90.997 19.8575 91.9645 20.96C92.932 22.0625 93.4045 23.4125 93.4045 25.0325C93.4045 26.6525 92.932 28.0025 91.9645 29.105C90.997 30.2075 89.782 30.77 88.3195 30.77ZM87.757 28.79C89.6695 28.79 90.862 27.35 90.862 25.0325C90.862 22.715 89.6695 21.2975 87.757 21.2975C86.8795 21.2975 86.1145 21.6575 85.507 22.3775C84.8995 23.0975 84.5845 23.975 84.5845 25.0325C84.5845 26.09 84.8995 26.99 85.507 27.71C86.1145 28.43 86.8795 28.79 87.757 28.79ZM103.813 26.63L105.725 27.6875C104.69 29.735 102.98 30.77 100.618 30.77C98.9527 30.77 97.5802 30.23 96.5002 29.1725C95.4202 28.115 94.8802 26.7425 94.8802 25.0325C94.8802 23.345 95.4202 21.9725 96.4777 20.915C97.5352 19.8575 98.8627 19.3175 100.46 19.3175C102.058 19.3175 103.318 19.8125 104.24 20.825C105.163 21.8375 105.613 23.1875 105.613 24.875C105.613 25.2575 105.613 25.4825 105.59 25.595H97.4452C97.6027 27.575 98.7727 28.79 100.64 28.79C102.013 28.79 103.07 28.07 103.813 26.63ZM100.393 21.23C98.7952 21.23 97.6702 22.2425 97.4677 23.93H103.115C102.958 22.1975 102.035 21.23 100.393 21.23ZM110.556 30.5H108.126V19.5875H110.489V21.4775C111.096 20.105 112.131 19.4075 113.594 19.4075C115.326 19.4075 116.609 20.645 116.609 22.5575C116.609 23.0975 116.519 23.66 116.316 24.245L114.089 24.02C114.156 23.57 114.179 23.2775 114.179 23.12C114.179 21.995 113.706 21.4325 112.784 21.4325C111.524 21.4325 110.556 22.895 110.556 25.0775V30.5Z" fill="white"></path>
                              <path d="M126.407 30.5H123.909V14.8625H130.119C133.517 14.8625 135.722 16.7075 135.722 19.7C135.722 21.2075 135.204 22.3775 134.192 23.255C133.179 24.1325 131.807 24.56 130.119 24.56H126.407V30.5ZM126.407 17.045V22.3775H129.962C131.964 22.3775 133.089 21.41 133.089 19.7C133.089 17.99 131.964 17.045 129.962 17.045H126.407ZM140.241 30.5H137.811V19.5875H140.174V21.4775C140.781 20.105 141.816 19.4075 143.279 19.4075C145.011 19.4075 146.294 20.645 146.294 22.5575C146.294 23.0975 146.204 23.66 146.001 24.245L143.774 24.02C143.841 23.57 143.864 23.2775 143.864 23.12C143.864 21.995 143.391 21.4325 142.469 21.4325C141.209 21.4325 140.241 22.895 140.241 25.0775V30.5ZM149.331 17.7425C148.454 17.7425 147.824 17.135 147.824 16.3025C147.824 15.47 148.454 14.84 149.331 14.84C150.164 14.84 150.839 15.47 150.839 16.3025C150.839 17.1125 150.164 17.7425 149.331 17.7425ZM150.546 30.5H148.116V19.5875H150.546V30.5ZM158.358 30.77C156.693 30.77 155.343 30.2525 154.33 29.24C153.318 28.2275 152.8 26.8325 152.8 25.0325C152.8 23.39 153.318 22.04 154.353 20.9375C155.365 19.8575 156.648 19.3175 158.2 19.3175C160.9 19.3175 162.948 20.87 163.465 23.9075L161.193 24.515C160.788 22.3775 159.82 21.2975 158.268 21.2975C156.445 21.2975 155.343 22.715 155.343 25.0325C155.343 27.35 156.49 28.79 158.38 28.79C159.708 28.79 160.698 27.98 161.395 26.3375L163.398 27.395C162.295 29.645 160.608 30.77 158.358 30.77ZM173.686 26.63L175.598 27.6875C174.563 29.735 172.853 30.77 170.491 30.77C168.826 30.77 167.453 30.23 166.373 29.1725C165.293 28.115 164.753 26.7425 164.753 25.0325C164.753 23.345 165.293 21.9725 166.351 20.915C167.408 19.8575 168.736 19.3175 170.333 19.3175C171.931 19.3175 173.191 19.8125 174.113 20.825C175.036 21.8375 175.486 23.1875 175.486 24.875C175.486 25.2575 175.486 25.4825 175.463 25.595H167.318C167.476 27.575 168.646 28.79 170.513 28.79C171.886 28.79 172.943 28.07 173.686 26.63ZM170.266 21.23C168.668 21.23 167.543 22.2425 167.341 23.93H172.988C172.831 22.1975 171.908 21.23 170.266 21.23Z" fill="#FF7F00"></path>
                              </svg>
                          </span>
                        </div>
                      `
                    : ''
                }
              </div>
            </div>
          </div>
        </a>
      `;
    }
  );

  const WRAPPER_SELECTOR = '.ais-facet-dropdown-wrapper';
  const PRICE_CLASS = 'ais-facet-price';
  const STYLE_ID = 'aa-collapse-facets-css';

  /* -----------------------------
   * Inject collapse CSS once
   * ----------------------------- */
  if (!document.getElementById(STYLE_ID)) {
    const style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = `
      .aa-facet-collapsed .ais-facet-dropdown-container {
        display: none !important;
      }
      .ais-facet-dropdown-wrapper:not(.aa-facet-collapsed) .ais-facet-dropdown-container {
        display: block !important;
      }
      .ais-facet-dropdown-wrapper > label {
        cursor: pointer;
      }
      .pli-wrapper .member-price-label {
            color: #FF7F00;
            font-weight: 600;
            font-size: 14px !important;
            vertical-align: middle;
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            align-content: flex-start;
      }
      .ais-page .pli-wrapper {
        margin-top: 7px;
      }
      .aa-ItemContentPrice {
        display: flex;
        align-items: center;
        gap: 10px;
        flex-wrap: nowrap;
        white-space: nowrap;
      }

      .aa-MemberPriceWrapper {
        display: flex;
        align-items: center;
        gap: 6px;
      }

      .member-price-amount {
        color: #000;
        font-size: 12px;
        font-weight: 600;
        line-height: 1;
      }

      .member-price-badge {
        display: flex;
        align-items: center;
      }

      .aa-PanelSection .member-price-svg {
        width: 80px;
        height: 18px;
        display: block;
      }
    `;
    document.head.appendChild(style);
  }

  /* -----------------------------
   * Detect active refinement (ROBUST)
   * ----------------------------- */
  function hasSelectedRefinement(wrapper) {
    return (
      wrapper.querySelector('[aria-current="true"]') ||
      wrapper.querySelector('.ais-RefinementList-item--selected') ||
      wrapper.querySelector('input[type="checkbox"]:checked') ||
      wrapper.querySelector('.ais-RangeSlider .ais-RangeSlider-handle') ||
      wrapper.querySelector('.ais-RangeInput-input[value]:not([value=""])')
    );
  }

  /* -----------------------------
   * Init facet (events only)
   * ----------------------------- */
  function initFacet(wrapper) {
    if (wrapper.dataset.aaFacetInit === '1') return;
    wrapper.dataset.aaFacetInit = '1';

    const label = wrapper.querySelector('label');
    if (!label) return;

    label.addEventListener('click', (e) => {
      e.preventDefault();
      wrapper.classList.toggle('aa-facet-collapsed');
      label.setAttribute(
        'aria-expanded',
        String(!wrapper.classList.contains('aa-facet-collapsed'))
      );
    });
  }

  /* -----------------------------
   * Apply open / close state (EVERY render)
   * ----------------------------- */
  function applyFacetState(wrapper) {
    const hasSelection = hasSelectedRefinement(wrapper);

    let shouldCollapse;

    if (hasSelection) {
      shouldCollapse = false; // keep open if selected
    } else {
      shouldCollapse = false; // ALL OPEN by default
    }

    wrapper.classList.toggle('aa-facet-collapsed', shouldCollapse);

    const label = wrapper.querySelector('label');
    if (label) {
      label.setAttribute('aria-expanded', 'true');
    }
  }

  /* -----------------------------
   * InstantSearch render
   * ----------------------------- */
  document.addEventListener('algolia.instantSearch.onRender', () => {
    /* Facet collapse logic */
    document.querySelectorAll(WRAPPER_SELECTOR).forEach(wrapper => {
      initFacet(wrapper);
      applyFacetState(wrapper);
    });

    /* Availability facet TRUE/FALSE label conversion */
    document.querySelectorAll(
      '.ais-facet-inventory_available .ais-RefinementList-label'
    ).forEach(label => {

      const count = label.querySelector('.ais-RefinementList-count');

      if (!count) return;

      const rawText = label.childNodes[0]?.textContent?.trim();

      if (rawText === 'true') {
        label.childNodes[0].textContent = 'In stock ';
      }

      if (rawText === 'false') {
        label.childNodes[0].textContent = 'Out of stock ';
      }
    });
  });

  algoliaShopify.hooks.registerHook('beforeInstantSearchProductTemplate', function(_defaultTemplate, hit, html, components) {

      // Custom placeholder image logic
      const placeholder = "https://cdn.shopify.com/s/files/1/0790/6030/4123/files/No-img.png";
      let productImage = algoliaShopify.helpers.largeImage(hit);
      if (!productImage || productImage.includes('no-image') || productImage.includes('no_image')) {
        productImage = placeholder;
      }

      const now = Date.now();
      const availableDate = hit?.meta?.custom?.avail_since
        ? new Date(hit.meta.custom.avail_since).getTime()
        : null;

      const isComingSoon = availableDate && availableDate > now;

      window.openQuickView = async function(hit) {
        const dialog = document.querySelector("#quick-add-dialog dialog");
        const content = document.querySelector("#quick-add-modal-content");
        if (!dialog || !content) return;

        dialog.showModal();
        content.innerHTML = '';

        try {
          const url = `/products/${hit.handle}?view=quick-view`;
          const res = await fetch(url);
          const html = await res.text();

          const doc = new DOMParser().parseFromString(html, 'text/html');
          const quickViewContent = doc.querySelector('#QuickViewContent');

          content.innerHTML = quickViewContent ? quickViewContent.innerHTML : '<p>Failed to load product</p>';

        } catch (err) {
          content.innerHTML = `<p>Failed to load product</p>`;
          console.error(err);
        }
      };

    const isSoldOut = false;
    const isSale =
      hit.compare_at_price &&
      hit.price &&
      hit.compare_at_price > hit.price;

    let badgeText = null;
    let badgeClass = '';
    let hitCanOrder = true;

    if (isSoldOut && hit.can_order == false) {
      badgeText = 'Sold out';
      badgeClass = 'sold-out';
      hitCanOrder = hit.can_order;
    } else if (isSale) {
      badgeText = 'Sale';
      badgeClass = 'sale';
    }

    console.log("RATING DATA →", hit);

    let rating = null;
    let ratingCount = hit.meta?.reviews?.rating_count;

    try {
      const ratingObj = JSON.parse(hit.meta?.reviews?.rating || '{}');
      if (ratingObj?.value && !isNaN(ratingObj.value)) {
        rating = parseFloat(ratingObj.value);
      }
    } catch (e) {
      console.log("Rating parse failed", e);
    }

    let badge = null;

    console.log(hit.meta?.custom?.is_new);

    // Badge priority: Clearance > New > Discount
    // Clearance (highest priority)
    if (hit.meta?.custom?.clearance_tag) {
      badge = hit.meta.custom.clearance_tag;
    }
    // New
    else if (hit.meta?.custom?.is_new === true || hit.meta?.custom?.is_new === "true") {
      badge = "New";
    }
    // Special Order (commented out)
    /*else if (hit.meta?.custom?.order_tag === "Special Order") {
      badge = "Special Order";
    }*/
    // Discount (lowest priority)
    else if (hit.compare_at_price > hit.price) {
      const discount = Math.round(((hit.compare_at_price - hit.price) / hit.compare_at_price) * 100);
      badge = `-${discount}%`;
    }
    console.log(algoliaShopify.helpers.largeImage(hit));
    return html`
      <div
        class="ais-hit ais-product"
        data-algolia-index="${hit.index}"
        data-algolia-position="${hit.productPosition}"
        data-algolia-queryid="${hit.queryID}"
        data-algolia-objectid="${hit.objectID}"
        data-handle="${hit.handle}"
        data-distinct="${hit._distinct}"
        data-product-id="${hit.id}"
        onClick="${() => algoliaShopify.helpers.handleItemClick(hit)}"
      >
      ${badge && html`
        <div class="product-badges product-badges--top-right">
          <div class="product-badges__badge product-badges__badge--rectangle color-scheme-1">
            <div class="${badgeClass}">${badge}</div>
          </div>
        </div>
      `}

        <div class="img-container">
          <img
            class="ais-hit--picture"
            src="${productImage}"
            alt="${hit.title} - ${hit.variant_title}"
          />
        </div>
    
        <div class="ais-hit--details">
          ${hit.vendor && hit.vendor.toLowerCase() !== 'tranzmile truck & trailer parts'
            ? html`
                <div class="ais-hit--vendor">
                    ${hit.vendor}
                </div>
              `
            : html`
                <div class="ais-hit--vendor ais-hit--vendor-empty"></div>
              `
          }
          <p class="ais-hit--title">
            <a
              data-algolia-index="${hit.index}"
              data-algolia-position="${hit.productPosition}"
              data-algolia-queryid="${hit.queryID}"
              data-algolia-objectid="${hit.objectID}"
              href="/products/${hit.handle}"
              title="${algoliaShopify.helpers.fullTitle(
                hit.title,
                hit._distinct,
                hit.variant_title
              )}"
            >
              ${components.Highlight({ attribute: 'title', hit })}
              ${algoliaShopify.helpers.variantTitleAddition(hit, hit._distinct)}
            </a>
          </p>

          ${!hit._distinct &&
            html`
              <span class="ais-hit--price-discount"
                >${algoliaShopify.helpers.displayDiscount(
                  hit.price,
                  hit.compare_at_price,
                  hit.price_ratio
                )}</span
              >
            `}

          ${isComingSoon
            ? html`
                <div class="coming-soon">
                  <span class="coming-soon-main">Coming Soon</span>
                </div>
              `
            : ''}
            <p class="ais-hit--price">
              <span class="ais-hit--price-current${isCustomerLoggedIn ? ' login_member_price' : ''}">
                ${algoliaShopify.helpers.displayPrice(hit)}
              </span>

              ${hit.compare_at_price > hit.price ? html`
                <span class="ais-hit--price-original${isCustomerLoggedIn ? ' login_member_price' : ''}">
                  ${algoliaShopify.helpers.displayComparePrice(hit)}
                </span>
              ` : ''}

              ${hit.meta.custom && hit.meta.custom.custom_member_price ? html`
                <div class="pli-wrapper${isCustomerLoggedIn ? ' login_member_price' : ''}">
                  <span class="member-price-label">
                    $${parseFloat(hit.meta.custom.custom_member_price).toFixed(2)}
                    <svg width="205" height="25" viewBox="0 0 205 45" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <rect width="205" height="45" rx="4.5" fill="black"></rect>
                    <path d="M32.32 30.5H29.8225V14.8625H33.355L38.1025 24.605L42.7375 14.8625H46.2925V30.5H43.795V17.8775L39.205 27.3725H36.8875L32.32 17.8775V30.5ZM57.78 26.63L59.6925 27.6875C58.6575 29.735 56.9475 30.77 54.585 30.77C52.92 30.77 51.5475 30.23 50.4675 29.1725C49.3875 28.115 48.8475 26.7425 48.8475 25.0325C48.8475 23.345 49.3875 21.9725 50.445 20.915C51.5025 19.8575 52.83 19.3175 54.4275 19.3175C56.025 19.3175 57.285 19.8125 58.2075 20.825C59.13 21.8375 59.58 23.1875 59.58 24.875C59.58 25.2575 59.58 25.4825 59.5575 25.595H51.4125C51.57 27.575 52.74 28.79 54.6075 28.79C55.98 28.79 57.0375 28.07 57.78 26.63ZM54.36 21.23C52.7625 21.23 51.6375 22.2425 51.435 23.93H57.0825C56.925 22.1975 56.0025 21.23 54.36 21.23ZM75.1435 19.3175C77.7535 19.3175 79.1935 20.9375 79.1935 23.705V30.5H76.7635V23.9975C76.7635 22.2425 76.021 21.365 74.5135 21.365C72.961 21.365 71.8585 22.3775 71.8585 24.11V30.5H69.406V23.9975C69.406 22.2425 68.6635 21.365 67.1785 21.365C65.626 21.365 64.5235 22.3775 64.5235 24.0875V30.5H62.0935V19.5875H64.456V21.0275C65.221 19.88 66.346 19.3175 67.8085 19.3175C69.496 19.3175 70.6435 19.9475 71.296 21.23C72.1735 19.9475 73.456 19.3175 75.1435 19.3175ZM88.3195 30.77C86.587 30.77 85.327 30.095 84.517 28.745V30.5H82.1545V14.8625H84.5845V21.275C85.417 19.97 86.677 19.3175 88.342 19.3175C89.782 19.3175 90.997 19.8575 91.9645 20.96C92.932 22.0625 93.4045 23.4125 93.4045 25.0325C93.4045 26.6525 92.932 28.0025 91.9645 29.105C90.997 30.2075 89.782 30.77 88.3195 30.77ZM87.757 28.79C89.6695 28.79 90.862 27.35 90.862 25.0325C90.862 22.715 89.6695 21.2975 87.757 21.2975C86.8795 21.2975 86.1145 21.6575 85.507 22.3775C84.8995 23.0975 84.5845 23.975 84.5845 25.0325C84.5845 26.09 84.8995 26.99 85.507 27.71C86.1145 28.43 86.8795 28.79 87.757 28.79ZM103.813 26.63L105.725 27.6875C104.69 29.735 102.98 30.77 100.618 30.77C98.9527 30.77 97.5802 30.23 96.5002 29.1725C95.4202 28.115 94.8802 26.7425 94.8802 25.0325C94.8802 23.345 95.4202 21.9725 96.4777 20.915C97.5352 19.8575 98.8627 19.3175 100.46 19.3175C102.058 19.3175 103.318 19.8125 104.24 20.825C105.163 21.8375 105.613 23.1875 105.613 24.875C105.613 25.2575 105.613 25.4825 105.59 25.595H97.4452C97.6027 27.575 98.7727 28.79 100.64 28.79C102.013 28.79 103.07 28.07 103.813 26.63ZM100.393 21.23C98.7952 21.23 97.6702 22.2425 97.4677 23.93H103.115C102.958 22.1975 102.035 21.23 100.393 21.23ZM110.556 30.5H108.126V19.5875H110.489V21.4775C111.096 20.105 112.131 19.4075 113.594 19.4075C115.326 19.4075 116.609 20.645 116.609 22.5575C116.609 23.0975 116.519 23.66 116.316 24.245L114.089 24.02C114.156 23.57 114.179 23.2775 114.179 23.12C114.179 21.995 113.706 21.4325 112.784 21.4325C111.524 21.4325 110.556 22.895 110.556 25.0775V30.5Z" fill="white"></path>
                    <path d="M126.407 30.5H123.909V14.8625H130.119C133.517 14.8625 135.722 16.7075 135.722 19.7C135.722 21.2075 135.204 22.3775 134.192 23.255C133.179 24.1325 131.807 24.56 130.119 24.56H126.407V30.5ZM126.407 17.045V22.3775H129.962C131.964 22.3775 133.089 21.41 133.089 19.7C133.089 17.99 131.964 17.045 129.962 17.045H126.407ZM140.241 30.5H137.811V19.5875H140.174V21.4775C140.781 20.105 141.816 19.4075 143.279 19.4075C145.011 19.4075 146.294 20.645 146.294 22.5575C146.294 23.0975 146.204 23.66 146.001 24.245L143.774 24.02C143.841 23.57 143.864 23.2775 143.864 23.12C143.864 21.995 143.391 21.4325 142.469 21.4325C141.209 21.4325 140.241 22.895 140.241 25.0775V30.5ZM149.331 17.7425C148.454 17.7425 147.824 17.135 147.824 16.3025C147.824 15.47 148.454 14.84 149.331 14.84C150.164 14.84 150.839 15.47 150.839 16.3025C150.839 17.1125 150.164 17.7425 149.331 17.7425ZM150.546 30.5H148.116V19.5875H150.546V30.5ZM158.358 30.77C156.693 30.77 155.343 30.2525 154.33 29.24C153.318 28.2275 152.8 26.8325 152.8 25.0325C152.8 23.39 153.318 22.04 154.353 20.9375C155.365 19.8575 156.648 19.3175 158.2 19.3175C160.9 19.3175 162.948 20.87 163.465 23.9075L161.193 24.515C160.788 22.3775 159.82 21.2975 158.268 21.2975C156.445 21.2975 155.343 22.715 155.343 25.0325C155.343 27.35 156.49 28.79 158.38 28.79C159.708 28.79 160.698 27.98 161.395 26.3375L163.398 27.395C162.295 29.645 160.608 30.77 158.358 30.77ZM173.686 26.63L175.598 27.6875C174.563 29.735 172.853 30.77 170.491 30.77C168.826 30.77 167.453 30.23 166.373 29.1725C165.293 28.115 164.753 26.7425 164.753 25.0325C164.753 23.345 165.293 21.9725 166.351 20.915C167.408 19.8575 168.736 19.3175 170.333 19.3175C171.931 19.3175 173.191 19.8125 174.113 20.825C175.036 21.8375 175.486 23.1875 175.486 24.875C175.486 25.2575 175.486 25.4825 175.463 25.595H167.318C167.476 27.575 168.646 28.79 170.513 28.79C171.886 28.79 172.943 28.07 173.686 26.63ZM170.266 21.23C168.668 21.23 167.543 22.2425 167.341 23.93H172.988C172.831 22.1975 171.908 21.23 170.266 21.23Z" fill="#FF7F00"></path>
                    </svg>
                  </span>
                </div>
              ` : ''}
            </p>

          <div class="addtocart-price-section">
            ${!hit._distinct && hit.price > 0 &&
              html`
                <p class="ais-hit--cart">
                  <a
                    href="/products/${hit.handle}"
                    class="ais-hit--cart-button ais-hit--view-more-button"
                    onClick="${(e) => { e.stopPropagation(); }}"
                  >
                    <span>
                      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16" fill="none">
                        <path d="M1.06251 8.34738C0.979165 8.12287 0.979165 7.8759 1.06251 7.65138C1.87421 5.68324 3.25202 4.00042 5.02128 2.81628C6.79053 1.63214 8.87155 1 11.0005 1C13.1295 1 15.2105 1.63214 16.9797 2.81628C18.749 4.00042 20.1268 5.68324 20.9385 7.65138C21.0218 7.8759 21.0218 8.12287 20.9385 8.34738C20.1268 10.3155 18.749 11.9983 16.9797 13.1825C15.2105 14.3666 13.1295 14.9988 11.0005 14.9988C8.87155 14.9988 6.79053 14.3666 5.02128 13.1825C3.25202 11.9983 1.87421 10.3155 1.06251 8.34738Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                        <path d="M11.0005 10.9994C12.6574 10.9994 14.0005 9.65624 14.0005 7.99938C14.0005 6.34253 12.6574 4.99938 11.0005 4.99938C9.34365 4.99938 8.00051 6.34253 8.00051 7.99938C8.00051 9.65624 9.34365 10.9994 11.0005 10.9994Z" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                      </svg>
                      View More
                    </span>
                  </a>
                </p>
              `}
          </div>

          <!-- Extra info examples - Remove the display: none to show them -->
          <p class="ais-hit--info" style="display: none">
            ${hit.sku &&
              html`
                <span class="algolia-sku"
                  >${components.Highlight({ attribute: 'sku', hit })}</span
                >
              `}
            ${hit.barcode &&
              html`
                <span class="algolia-barcode"
                  >${components.Highlight({ attribute: 'barcode', hit })}</span
                >
              `}
            ${hit.weight &&
              html`
                <span class="algolia-weight">${hit.weight}</span>
              `}
            ${!hit.taxable &&
              html`
                <span class="algolia-taxable"
                  >${algoliaShopify.translations.taxFree}</span
                >
              `}
          </p>
          <!-- Tags example - Remove the display: none to show them -->
          <p class="ais-hit--tags" style="display: none">
            ${hit?._highlightResult.tags?.map(
              tag =>
                html`
                  <span class="ais-hit--tag">${tag.value}</span>
                `
            )}
          </p>
        </div>       
      </div>
      <a class="ydp-wishlist-icon-ais" href="/products/${hit.handle}"></div>
    `;
  });

  algoliaShopify.hooks.registerHook('beforeInstantSearchMainTemplate', function(_defaultTemplate, data, html) {
 
    return html`
      <div class="ais-page">
        <h2 class="ais-h2">${algoliaShopify.translations.searchTitle}</h2>
        <div class="ais-input">
          <div class="ais-search-box-container"></div>
          <div class="ais-input-button">
            <div class="ais-clear-input-icon"></div>
          </div>
        </div>
        <div class="ais-facets-button">
          ${algoliaShopify.translations.showFilters}
        </div>
        <div class="ais-facets">
          <div class="ais-facets-container">
          <div class="ais-clear-refinements-container"></div>
          <div class="ais-current-refined-values-container"></div>
          <div class="ais-facet-dropdown-wrapper ais-facet-collections">
            <label class="ais-range-slider--header ais-facet--header ais-header">CATEGORY</label>
            <div class="ais-facet-dropdown-container">
              <div class="price-facet__collections-radio">
                <ul>
                  ${(window.allCollections || []).map(col => html`
                    <li>
                      <a href="${col.url}">${col.title}</a>
                    </li>
                  `)}
                </ul>
              </div>
            </div>
          </div>
          
          ${algoliaShopify.config.app_blocks_dynamic_widgets_beta_enabled
            ? html`
                <div class="ais-dynamic-widgets-container"></div>
              `
            : data.facets.map(
                facet =>
                  html`
                    <div
                      class="ais-facet-dropdown-wrapper ais-facet-${facet.type} ais-facet-${facet.escapedName}"
                    >
                      <input
                        class="ais-dropdown-checkbox"
                        type="checkbox"
                        id="${facet.escapedName}"
                        name="dropdown"
                      />
                      <label
                        for="${facet.escapedName}"
                        class="ais-range-slider--header ais-facet--header ais-header"
                        >${facet.title}</label
                      >
                      <div
                        class="ais-facet-${facet.escapedName}-container ais-facet-dropdown-container"
                      ></div>
                    </div>
                  `
              )}
          </div>
        </div>
        <div class="ais-block">
          <div class="ais-search-header">
            <div class="ais-change-display">
              <span class="ais-change-display-block ais-change-display-selected"
                ><i class="fa fa-th-large"></i
              ></span>
              <span class="ais-change-display-list"
                ><i class="fa fa-th-list"></i
              ></span>
            </div>
            <div class="ais-sort">
              ${data.multipleSortOrders
                ? html`
                    ${algoliaShopify.translations.sortBy}
                    <span class="ais-sort-orders-container"></span>
                  `
                : html`
                    ${algoliaShopify.translations.sortBy}
                    ${algoliaShopify.translations.relevance}
                  `}
            </div>
            <div class="ais-stats-container"></div>
          </div>
          <div class="ais-hits-container ais-results-as-block"></div>
        </div>
        <div class="ais-pagination-container"></div>
      </div>
    `;
  });

});
